import React from 'react';
import { styled } from '@mui/material/styles';

const GraphContainer = styled('div')(({ theme }) => ({
  height: '100%',
  width: '100%',
  position: 'relative',
}));

const SVGContainer = styled('svg')({
  width: '100%',
  height: '100%',
  overflow: 'visible',
});

// Brand Violet Colors
const Path = styled('path')({
  fill: 'none',
  stroke: '#8b5cf6', // Violet-500
  strokeWidth: '2px',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  vectorEffect: 'non-scaling-stroke',
});

const Area = styled('path')({
  fill: 'url(#gradient)', // Use simplified gradient ref
  strokeWidth: 0,
});

function ActivityGraph({ data = [] }) {
  const defaultData = Array(30).fill(0);
  const points = (data.length ? data : defaultData);

  // Normalize
  const maxValue = Math.max(...points, 1);
  const normalizedPoints = points.map(p => p / maxValue);

  // Smooth Path Generation
  const createPath = (points) => {
    const width = 100;
    const height = 100; // viewBox height
    const segments = points.length - 1;
    const segmentWidth = width / segments;

    let path = '';
    points.forEach((point, i) => {
      const x = i * segmentWidth;
      const y = height - (point * height); // Invert Y for SVG coordinates

      if (i === 0) {
        path += `M ${x},${y}`;
      } else {
        const prevX = (i - 1) * segmentWidth;
        const prevY = height - (points[i - 1] * height);

        const tension = 0.25;
        const horizontalOffset = segmentWidth * tension;

        const cp1x = prevX + horizontalOffset;
        const cp1y = prevY;
        const cp2x = x - horizontalOffset;
        const cp2y = y;

        path += ` C ${cp1x},${cp1y} ${cp2x},${cp2y} ${x},${y}`;
      }
    });
    return path;
  };

  const createAreaPath = (points) => {
    const linePath = createPath(points);
    return `${linePath} L 100,100 L 0,100 Z`;
  };

  const pathD = createPath(normalizedPoints);
  const areaPathD = createAreaPath(normalizedPoints);

  return (
    <GraphContainer>
      <SVGContainer viewBox="0 0 100 100" preserveAspectRatio="none">
        <defs>
          <linearGradient id="gradient" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#8b5cf6" stopOpacity="0.2" />
            <stop offset="100%" stopColor="#8b5cf6" stopOpacity="0" />
          </linearGradient>
        </defs>
        <Area d={areaPathD} />
        <Path d={pathD} />
      </SVGContainer>
    </GraphContainer>
  );
}

export default ActivityGraph;